import {
  abortableFetch,
  DetailContext,
  useEventCallback,
} from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';
import { useContext } from 'react';

export function useGenerateApiKeyDialog() {
  const { source } = useContext(DetailContext);

  const callApi = useEventCallback((id: string) => {
    return abortableFetch(
      `${EvidenceApiUrl.SYSTEM_USERS}/${id}/integration-key/generate`,
      {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      }
    );
  });

  const showButton = !source.data?.apiKeyHash;

  return { callApi, showButton };
}
